import { SidebarHeader } from '@/components/atoms/Sidebar';

import SellerBoxLogo from '@/assets/icons/Sidebar/sellerbox-logo.svg?react';
import { useSidebar } from '@/components/atoms/Sidebar';

export function AppSidebarHeader() {
  const { isMobile } = useSidebar(); // 'expanded' | 'collapsed'

  return (
    <SidebarHeader className={`transition-all duration-100 `}>
      <a
        className={`flex items-center gap-[8px] px-[16px] hover:bg-transparent ${
          isMobile && 'mt-[60px]'
        }`}
        href={'/'}
      >
        <SellerBoxLogo />
      </a>
    </SidebarHeader>
  );
}
